import { User } from "@models/user";

export class TimelineHelper {
    public static canCurrentUserEdit(currentUser: User, creatorId?: string) {
        const { roles, staffId } = currentUser
        return (
            (roles && roles.includes('administrator')) ||
            (staffId && creatorId && staffId === creatorId)
        )
    }
}



// WEBPACK FOOTER //
// ./src/helper/timeline.helper.ts